import { c as _c } from "react/compiler-runtime";
import { useMachine } from '@xstate/react';
import constate from 'constate';
import type { IdvMachineArgs } from '../../utils/state-machine';
import createIdvMachine from '../../utils/state-machine';
type IdvMachineProviderArgs = {
  args: IdvMachineArgs;
};
const useLocalIdvMachine = t0 => {
  const $ = _c(2);
  const {
    args
  } = t0;
  let t1;
  if ($[0] !== args) {
    t1 = () => createIdvMachine(args);
    $[0] = args;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return useMachine(t1);
};
export const [MachineProvider, useIdvMachine] = constate(useLocalIdvMachine);
export default MachineProvider;